(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dd-ndd-hero"] && !Shopify.designMode) return;
  try {
    
  /* DD · NDD — el video del hero solo se pide donde toca: nunca con prefers-reduced-motion,
     nunca en móvil si hay foto móvil (la placa vertical manda ahí). R2 primero y el mp4 de
     Shopify de respaldo, como en dd-hero. La foto queda de poster mientras carga. */
  (function () {
    var videos = document.querySelectorAll('.dd-ndd__video');
    if (!videos.length) { return; }
    var mobile = window.matchMedia('(max-width: 900px)').matches;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    for (var i = 0; i < videos.length; i++) {
      var v = videos[i];
      if (reduce || (mobile && v.hasAttribute('data-mobile-still'))) { v.remove(); continue; }
      var list = [];
      if (mobile && v.getAttribute('data-src-mobile')) { list.push(v.getAttribute('data-src-mobile')); }
      if (v.getAttribute('data-src')) { list.push(v.getAttribute('data-src')); }
      if (v.getAttribute('data-src-fallback')) { list.push(v.getAttribute('data-src-fallback')); }
      if (!list.length) { v.remove(); continue; }
      for (var j = 0; j < list.length; j++) {
        var source = document.createElement('source');
        source.src = list[j]; source.type = 'video/mp4';
        v.appendChild(source);
      }
      v.addEventListener('canplay', function (e) { e.target.classList.add('is-ready'); arranca(e.target); }, { once: true });
      v.load();
    }

    /* El play() no puede salir en el mismo tick que el load(): la promesa se aborta y el
       .catch se la traga, y el hero se queda en el primer cuadro. Se pide en canplay, y si
       el navegador aun asi lo niega, al primer gesto o scroll. */
    function arranca(v) {
      var p = v.play();
      if (p && p.catch) {
        p.catch(function () {
          if (v.dataset.ddReintento) { return; }
          v.dataset.ddReintento = '1';
          var go = function () { var r = v.play(); if (r && r.catch) { r.catch(function () {}); } };
          ['pointerdown', 'touchstart', 'scroll'].forEach(function (ev) {
            document.addEventListener(ev, go, { once: true, passive: true });
          });
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
